function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 2C6.475 2 2 6.475 2 12C2 17.525 6.475 22 12 22C17.525 22 22 17.525 22 12C22 6.475 17.525 2 12 2ZM6.1 6.1C8.025 4.175 10.75 3.3 13.525 3.8C14.625 4 15.65 4.4 16.575 5.025C17.65 5.75 18.525 6.675 19.15 7.725C19.35 8.075 19.225 8.55 18.85 8.725L18.5 8.875C16.85 9.65 14.95 9.65 13.3 8.925C12.9 8.75 12.45 8.65 12 8.65C11.55 8.65 11.1 8.75 10.7 8.925C9.025 9.65 7.15 9.65 5.5 8.875L5.15 8.725C4.775 8.55 4.625 8.1 4.85 7.75C5.2 7.15 5.625 6.6 6.1 6.1ZM12.075 13.675C11.075 13.725 10.275 12.925 10.325 11.925C10.375 11.075 11.05 10.4 11.9 10.35C12.9 10.3 13.7 11.1 13.65 12.1C13.625 12.925 12.925 13.625 12.075 13.675ZM3.675 12C3.675 11.525 4.1 11.2 4.55 11.325L5.9 11.675C7.275 12.05 8.5 12.85 9.35 13.975C9.375 14 9.375 14.025 9.4 14.05C10.425 15.35 10.925 16.975 10.8 18.625L10.725 19.45C10.7 19.875 10.275 20.175 9.85 20.05C8.45 19.675 7.175 18.95 6.125 17.9C4.525 16.325 3.675 14.225 3.675 12ZM17.9 17.9C16.85 18.95 15.575 19.675 14.175 20.05C13.75 20.15 13.35 19.875 13.3 19.45L13.225 18.625C13.075 16.975 13.6 15.35 14.625 14.05C14.65 14.025 14.65 14 14.675 13.975C15.525 12.85 16.75 12.05 18.125 11.675L19.475 11.325C19.925 11.2 20.35 11.525 20.35 12C20.325 14.225 19.475 16.325 17.9 17.9Z",
  fill: "current"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24"
    }, props), _ref)
  );
};

export default __webpack_public_path__ + "static/media/direction.bd17b081.svg";
export { SvgComponent as ReactComponent };